module.exports = __webpack_public_path__ + "media/brands-banner/ArtkiveGrayscaleLogo-70c26edf.svg";